import examActions from "../Redux/exam/actions";

export function auditLog({ data, dispatch, heartBeat }) {
  const logData = {
    srNo: data?.srNo,
    auditLog: [
      {
        ...data,
        Timestamp: heartBeat?.data,
      },
    ],
  };  
  dispatch({ type: examActions.AUDIT_LOG, payload: { data: logData } });
}
